import '../PlicCanvas/vue/utils/polyfills';

require('../PlicCanvas/js/layout-preview.js');
require('../PlicCanvas/css/layout-preview.css');
require('../PlicCanvas/js/flow-layout/svg-fonts.js');
require('../PlicCanvas/js/flow-layout/dynamic-variable-globals.js');
require('../PlicCanvas/js/flow-layout/frame-utils.js');
require('../PlicCanvas/vue/common/common-libs');

Vue.config.productionTip = false;